function game_301()
{

}

game_301.odd_map  = {
  "9":[0,0,100,400,1000],
  "8":[0,0,50,200,500],
  "7":[0,0,30,50,400],
  "6":[0,0,20,40,200],
  "5":[0,0,10,20,100],
  "4":[0,0,10,20,100],
  "3":[0,0,5,10,50],
  "2":[0,0,5,10,50],
  "1":[0,0,5,10,50],
};

export {
  game_301
};



// WEBPACK FOOTER //
// ./src/components/slots/game_301.js